"use client";

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { AlertTriangle, Clock } from 'lucide-react';

interface InactivityWarningModalProps {
  timeRemaining: number; // in milliseconds
  onStayActive: () => void;
}

export function InactivityWarningModal({ timeRemaining }: InactivityWarningModalProps) {
  // Convert milliseconds to minutes and seconds
  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);

  const formatTime = (mins: number, secs: number) => {
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent 
        className="sm:max-w-md bg-gray-900 border-white/20 text-white [&>button]:hidden" 
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-yellow-500/20 rounded-full">
              <AlertTriangle className="h-6 w-6 text-yellow-400" />
            </div>
            <DialogTitle className="text-xl">Session Timeout Warning</DialogTitle>
          </div>
          <DialogDescription className="text-white/70">
            You have been inactive for 20 minutes. Your session will automatically end soon.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <div className="flex items-center justify-center gap-4 p-6 bg-black/40 rounded-lg border border-yellow-500/30">
            <Clock className="h-8 w-8 text-yellow-400 animate-pulse" />
            <div className="text-center">
              <p className="text-sm text-white/60 mb-1">Time remaining:</p>
              <p className="text-3xl font-bold text-yellow-400 font-mono">
                {formatTime(minutes, seconds)}
              </p>
            </div>
          </div>
          
          <p className="text-sm text-white/60 mt-4 text-center">
            Move your mouse or press any key to stay active. Otherwise, you will be automatically logged out.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

